import { useCommonFetch } from "../../../../../hooks/useCommonFetch";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getJobopeningDetail,
  getJobopeningList,
} from "../../../../../services/workspace/recruitment.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import CustomTab, {
  TabContainer,
} from "../../../../components/tabs/customTabs";
import OverviewProfile from "./components/overview";
import ProfileCard from "./components/profileCard";
import TotalApplication from "./components/totalApplication";
import ShortListedApplication from "./components/shortListedApplication";
import InterviewList from "./components/interviewList";
import OnholdList from "./components/onHoldList";
import RejectedList from "./components/rejectedList";
import HiredList from "./components/hiredList";
import OfferedList from "./components/offeredList";
import CustomSelectFilter from "../../../../components/inputs/customSelectFilter";
import { DefaultSelectFilter } from "../../../../components/inputs/defaultSelectFilter";

const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
};

const items = [
  { label: "Job Opening", path: "/recruitment/job-opening" },
  { label: "Detail", path: "" },
];

const JobOpeningDetail = () => {
  const { search } = useLocation();
  const q = new URLSearchParams(search);

  const initialTab = parseInt(q.get("tab")) || 0;
  const [activeTab, setActiveTab] = useState(initialTab);
  const { id } = useParams();
  const [isEditValue, setIsEditValue] = useState(null);
  const { limit } = useSelector((state) => state.global);
  const navigate = useNavigate();
  // const [activeTab, setActiveTab] = useState(0);
  const [selectedRound, setSelectedRound] = useState(null);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}${selectedRound ? `&round=${selectedRound}` : ""}`);
    if (tabId !== 3) setSelectedRound(null); // reset filter if not on Schedule
  };

  const {
    loading,
    data: data,
    total: totalData,
  } = useCommonFetch(getJobopeningDetail, {
    id: id,
    dataPath: "jobOpening",
    totalPath: "jobOpening.meta.total",
    errorMessage: "Failed to fetch leave data!",
    debounceDelay: 500,
    customParams: {
      with: "department,rounds"
    },

    // dataTransformer: (data) => {
    //   if (Array.isArray(data)) {
    //     const transformedData = data.map((item) => ({
    //       ...item,

    //       id: {
    //         data: item.uuid,
    //         variant: "text",
    //       },

    //       name: {
    //         data: item.title || "-", // FIXED
    //         variant: "text",
    //       },

    //       department: {
    //         data: item.department_id || "-",
    //         variant: "text",
    //       },

    //       vacancies: {
    //         data: item.no_of_vacancies,
    //         variant: "number",
    //       },

    //       experience_required: {
    //         data: `${item.minimum_experience ?? 0} - ${
    //           item.maximum_experience ?? 0
    //         } Years`, // FIXED
    //         variant: "text",
    //       },

    //       location: {
    //         data: item.address || "-",
    //         variant: "text",
    //       },

    //       closing_date: {
    //         data: item.closing_date,
    //         variant: "date",
    //       },

    //       created_at: {
    //         data: item.created_at,
    //         variant: "date-time",
    //       },

    //       status: {
    //         data: item.status ? 1 : 0,
    //         variant: "status",
    //       },

    //       actions: {
    //         data: item.uuid,
    //         variant: "text",
    //       },
    //     }));

    //     const actionButton = {
    //       view: (item) => navigate(`/recruitment/detail/${item.id}`),

    //       edit: (item) => {
    //         navigate(`/recruitment/job-opening/edit/${item.id}`);
    //         setIsEditValue({
    //           id: item.id.data,
    //           title: item.title,
    //           department_id: item.department_id,
    //           no_of_vacancies: item.no_of_vacancies,
    //           employment_type: item.employment_type,
    //           work_mode: item.work_mode,
    //           opening_date: item.opening_date,
    //           closing_date: item.closing_date,
    //           address: item.address,
    //           minimum_education: item.minimum_education,
    //           preferred_education: item.preferred_education,
    //           minimum_experience: item.minimum_experience,
    //           maximum_experience: item.maximum_experience,
    //           key_skills: item.key_skills,
    //           job_responsibilities: item.job_responsibilities,
    //           perks_benefits: item.perks_benefits,
    //           currency: item.currency,
    //           salary_type: item.salary_type,
    //           salary_min: item.salary_min,
    //           salary_max: item.salary_max,
    //         });
    //       },

    //       onhold: (item) => {
    //         openModal();
    //       },
    //       cancel: (item) => {
    //         openModal();
    //       },
    //       publish: (item) => {
    //         openModal();
    //       },
    //       reopen: (item) => {
    //         openModal();
    //       },
    //     };

    //     return {
    //       data: transformedData,
    //       action: actionButton,
    //     };
    //   }

    //   return { data: [], action: {} };
    // },
  });

  // const handleTabChange = (tabId) => {
  //   setActiveTab(tabId);
  //   navigate(`?tab=${tabId}`);
  // };
  useEffect(() => {
    const current = parseInt(q.get("tab"));
    if (!isNaN(current)) setActiveTab(current);
  }, [search]);

  const tabs = [
    {
      id: "tab1",
      label: "Overview",
      content: (
        <OverviewProfile
            // fetchData={fetchData}
          data={data}
          loading={loading}
          //   heandleFetchData={heandleFetchData}
        />
      ),
    },
    {
      id: "tab2",
      label: `Total Applications(${data?.applied_count || 0})`,
      content: <TotalApplication />,
    },
    {
      id: "tab3",
      label: "Shortlisted",
      content: <ShortListedApplication rounds={data?.rounds || []} />,
    },
    {
      id: "tab4",
      label: "Schedule",
      content: (
        <InterviewList
          jobOpeningId={id}
          rounds={data?.rounds || []}
          selectedRound={selectedRound}
          setSelectedRound={setSelectedRound}
        />
      ),
    },
    {
      id: "tab5",
      label: "Onhold",
      content: <OnholdList />,
    },
    {
      id: "tab6",
      label: "Offered",
      content: <OfferedList />,
    },
    {
      id: "tab7",
      label: "Hired",
      content: <HiredList />,
    },
    {
      id: "tab8",
      label: "Rejected",
      content: <RejectedList />,
    },
  ];
  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader breadcrumbs={items} />
      <div className=" flex flex-col gap-2">
        <ProfileCard data={data} />
        <div className="flex flex-col gap-2 ">
          <div className="flex justify-between items-center mb-2">
            <CustomTab
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />
            {activeTab === 3 && (
              <CustomSelectFilter
                options={[]}
                value={""}
                onChange={""}
                placeholder={""}
                selectName={"Filter"}
              />
            )}
          </div>
          <div className="  scrollbar-hidden ">
            <TabContainer tabs={tabs} activeTab={activeTab} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobOpeningDetail;
